import { getVersion } from "../dom/screen";
import * as Board from "../components/board";
import { langId } from "@escapio/shared/l10n/lang-id";
import { session } from "../../shared/state/payload";
import { pageType } from "@escapio/portal/state/pageType";
import { travelData } from "../state/travelData";
import { getUtmQueryString } from "../state/utm";
import { getExperimentVersionsAsJSONString } from "../experiments/info";
import { getSecureSessionId } from "./secure-session-id";

export const HOTEL_PRICE_UNAVAILABLE = -2;
const DEFAULT_FILTERS = {
	board: undefined,
	cancelation: undefined,
};

// Not used anymore. Cleanup if still existing.
const STORAGE_KEY = "cached-prices";
localStorage.removeItem(STORAGE_KEY);

const PATH = "/price-comparer/fetch";

const experiments = getExperimentVersionsAsJSONString();

export function fetchPricesForCurrentTravelData(
	hotelIds,
	filters = DEFAULT_FILTERS,
) {
	return fetchPrices(hotelIds, travelData.formattedRequestParameter, filters);
}

export const fetchPrices = (
	hotelIds,
	travelDataParams,
	filters = DEFAULT_FILTERS,
) => {
	if (hotelIds.length <= 0) {
		const promise = Promise.resolve({});
		promise.isFulfilled = () => true;
		promise.cancel = () => undefined;
		return promise;
	}
	const url = new URL(`${location.origin}${PATH}`);
	const requestParameters = Object.assign(
		{
			lang_id: langId,
			sid: getSecureSessionId(),
			page_type: pageType,
			screen_size: getVersion(),
			mobile: session.is_mobile ? 1 : undefined, // Omit parameter, when false.
			hotels: hotelIds.join(","),
			utm: getUtmQueryString(),
			experiment_versions: experiments || undefined, // Omit parameter, when false.
			cancelation: filters.cancelation ? 1 : undefined, // Omit parameter, when false.
			board: filters.board === Board.NONE ? undefined : filters.board,
		},
		travelDataParams,
	);

	Object.entries(requestParameters).forEach(([key, value]) => {
		if (value !== undefined) {
			url.searchParams.set(key, value);
		}
	});

	let fulfilled = false;
	const abortController = new AbortController();
	const promise = fetch(url, { signal: abortController.signal })
		.then(response => response.json())
		.then(responseData => {
			const pricesPerHotel = responseData.hotels;

			hotelIds
				.filter(id => !pricesPerHotel.hasOwnProperty(id))
				.forEach(id => (pricesPerHotel[id] = HOTEL_PRICE_UNAVAILABLE));

			Object.keys(pricesPerHotel).forEach(hotelId => {
				if (pricesPerHotel[hotelId] !== HOTEL_PRICE_UNAVAILABLE) {
					pricesPerHotel[hotelId].providers = responseData.providers;
				}
			});

			return pricesPerHotel;
		})
		.finally(() => {
			fulfilled = true;
		});

	return {
		then: promise.then.bind(promise),
		catch: promise.catch.bind(promise),
		isFulfilled: () => fulfilled,
		cancel() {
			abortController.abort();
		},
	};
};
